import { ReactComponent as MonitorIcon } from "../../../../assets/icons/custom/monitor.svg";
import { QueueType } from "../../../../utils/get-appointment-card-prop";

const LeftPanelQueueCard = ({ queueType }: { queueType: QueueType }) => {
  let title = "Booked: ";
  let description = "See all your booked appointments here";
  let bottomText = "There are no booked appointments scheduled.";
  if (queueType === "followup") {
    title = "Follow up: ";
    description = "See all your follow up appointments here";
    bottomText = "There are no follow up appointments scheduled.";
  } else if (queueType === "others") {
    title = "Others: ";
    description = "See all your other appointments here";
    bottomText = "There are no other appointments.";
  }

  return (
    <div className="dr-flex dr-flex-col dr-items-center dr-h-full dr-py-32 dr-px-12">
      <div className="dr-space-x-8 TouchCalloutRegular">
        <span className="dr-text-darwin-touch-primary-primary">{title}</span>
        <span>{description}</span>
      </div>
      <div className="dr-flex-1 dr-space-y-16 dr-text-center dr-flex dr-flex-col dr-items-center dr-justify-center">
        <MonitorIcon className="dr-w-138 dr-h-120" />
        <div className="TouchFootnoteRegular dr-text-darwin-touch-neutral-600">
          {bottomText}
        </div>
      </div>
    </div>
  );
};

export default LeftPanelQueueCard;
